import { useDraft } from 'src/app/v2/hooks/useDraft';
import { mapToUpdateDraftJobInput } from 'src/app/v2/utils/mapToUpdateDraftJobInput';
import {
  useUpdateDraftJobMutation,
  type DraftJobFlowType,
  DraftStatus,
} from 'src/graphql/generated';

export const useCloseDraft = () => {
  const [updateDraftJob] = useUpdateDraftJobMutation();
  const draft = useDraft();

  const closeDraft = ({ flowType }: { flowType: DraftJobFlowType }) =>
    updateDraftJob({
      variables: {
        input: mapToUpdateDraftJobInput({
          draftJob: draft!,
          flowType,
          status: DraftStatus.CLOSED,
        }),
      },
    });

  return [closeDraft];
};
